import { useLogout } from "../../features/auth/api.js";
import { useBusinesses } from "../../features/businesses/api.js";
import { useBusiness } from "../../lib/business.js";
import { useTheme } from "../../lib/theme.js";
import { BizSwitch } from "./BizSwitch.js";
import { Icon } from "./Icon.js";
import { StatusPill } from "./StatusPill.js";
import styles from "./TopBar.module.css";

export function TopBar({ onOpenPalette }: { onOpenPalette: () => void }) {
  const { theme, toggle } = useTheme();
  const { activeId } = useBusiness();
  const businesses = useBusinesses();
  const logout = useLogout();

  const active = businesses.data?.find((b) => b.id === activeId);

  return (
    <header className={styles.bar}>
      <div className={styles.left}>
        <span className="wordmark">
          <span className="wm-name">Hillman</span>
          <span className="wm-tag">Services</span>
        </span>
        <span className={styles.divider} aria-hidden="true" />
        <span className={styles.product}>WhatsApp Control Panel</span>
        <span className={`${styles.divider} ${styles.dividerSm}`} aria-hidden="true" />
        <BizSwitch />
      </div>

      <div className={styles.right}>
        <button
          type="button"
          className={styles.iconBtn}
          onClick={onOpenPalette}
          aria-label="Open command palette"
          title="Command palette (⌘K)"
        >
          <Icon name="command" size={16} />
        </button>

        <button
          type="button"
          className={styles.iconBtn}
          onClick={toggle}
          aria-label="Toggle theme"
          title={theme === "light" ? "Switch to dark" : "Switch to light"}
        >
          <Icon name={theme === "light" ? "moon" : "sun"} size={16} />
        </button>

        <StatusPill business={active} />

        <button
          type="button"
          className={styles.iconBtn}
          onClick={() => logout.mutate()}
          aria-label="Sign out"
          title="Sign out"
        >
          <Icon name="logout" size={16} />
        </button>
      </div>
    </header>
  );
}
